import { CreateSessionButton } from "@/features/coaching/components";
import { AdminScreenContentLayout } from "@/features/coaching/layouts";
import {
  CoachingLabHeader,
  CoachingLabTabs,
} from "@/features/coaching/sections";

export const CoachingLab = () => {
  return (
    <AdminScreenContentLayout>
      <CoachingLabHeader />

      <CoachingLabTabs />

      <CreateSessionButton />
    </AdminScreenContentLayout>
  );
};
